import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {PolicyholderGroupDTO} from '../models/PolicyholderGroupDTO';

@Injectable({
  providedIn: 'root'
})
export class PolicyholderGroupService {
  private url = environment.baseUrl + '/policyholder-group';

  constructor(private httpClient: HttpClient) {
  }

  getListOfPolicyholderGroups(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<PolicyholderGroupDTO>> {
    return this.httpClient.post<PagedResponseDTO<PolicyholderGroupDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getPolicyholderGroup(providerId: number): Observable<PolicyholderGroupDTO> {
    return this.httpClient.get<PolicyholderGroupDTO>(this.url + '/' + providerId);
  }

  deletePolicyholderGroup(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

  savePolicyholderGroup(policyHolderGroupPayload: PolicyholderGroupDTO): Observable<PolicyholderGroupDTO> {
    return this.httpClient.post<PolicyholderGroupDTO>(this.url, policyHolderGroupPayload);
  }

}
